import { render, staticRenderFns } from "./1_TextQuestion.vue?vue&type=template&id=c7b2d1a4&scoped=true&"
import script from "./1_TextQuestion.vue?vue&type=script&lang=js&"
export * from "./1_TextQuestion.vue?vue&type=script&lang=js&"
import style0 from "./1_TextQuestion.vue?vue&type=style&index=0&id=c7b2d1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b2d1a4",
  null
  
)

export default component.exports